module.exports = __webpack_public_path__ + "img/xcx.9f10ccf2.png";